import React from "react";
import { Button, ButtonProps } from "@mui/material";

type PrimaryButtonProps = {
	isSubmitting?: boolean;
	label: string;
} & ButtonProps;

// Use React.forwardRef to allow refs to be passed
const PrimaryButton = React.forwardRef<HTMLButtonElement, PrimaryButtonProps>(
	({ isSubmitting = false, label, ...props }, ref) => {
		return (
			<Button
				ref={ ref } // Forward the ref to the MUI Button
				disabled={ isSubmitting }
				variant="contained"
				sx={ {
					textTransform: "capitalize",
					borderRadius: "8px",
					fontWeight: "500",
					fontSize: "13px",
					padding: "11px 30px",
					color: "#fff !important",
				} }
				{ ...props }
			>
				{ isSubmitting ? "Submitting..." : label }
			</Button>
		);
	}
);

// Set the display name for better debugging in React DevTools
PrimaryButton.displayName = "PrimaryButton";

export default PrimaryButton;
